module.exports = "<aside>\r\n  <eg-languages-list></eg-languages-list>\r\n</aside>\r\n"